import React from 'react';
import Progress from "./Progress";
import QuoteStepLayout from "../QuoteStepLayout";

interface IProps {
    id: string,
    children : any,
    className?: string;
}

export const QuoteStep = (props: IProps) => {
    return (
        <QuoteStepLayout id={props.id} children={props.children} className={props.className} progress={<Progress/>} />
    );
}